import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { caseIdSelector, caseImagesSelector } from '../../../../redux/selectors'
import ImageAlbums from './ImageAlbums'
import { makeStyles } from '@material-ui/styles'
import { CircularProgress, Container, Grid } from '@material-ui/core';
import EmptyImages from './EmptyImages'
import { injectIntl } from 'react-intl'
import { getCase, getCaseImages } from '../../../../redux/actions'
import * as cookies from '../../../../utilties/cookies'
import Paper from '@material-ui/core/Paper'

const useStyles = makeStyles((theme) => ({
	titleRoot: {
		color: 'white',
		fontWeight: '400',
		padding: '32px 0 24px',
		textAlign: 'left',
		textShadow: '0 1px 1px #000',
	}
}))

const AlbumsContainer = ({ intl, caseId, loadCase, loadImages, caseImages }) => {

	const classes = useStyles()
	const [patient] = useState(cookies.get('user'))

	useEffect(
		() => {
			loadCase(patient.id)

			if (caseId)
				loadImages(caseId)
		},
		[caseId]
	)

	const renderImages = caseImages && caseImages.hasImageQuestions && caseImages.albums && caseImages.albums.length

	return (
		<Grid data-testid="albums-container" className={classes.containerOuter}>
			<Grid container direction='column'>
				<Grid data-testid="albums-container-body">
					<Container maxWidth="lg">
						<Grid container style={{marginTop: '61px'}}>
							<Grid item xs={12}>
								<Paper style={{ padding: '2rem', minHeight: '300px' }} elevation={2}>
									{caseImages 
										? renderImages 
											? <ImageAlbums data-testid="albums-container-albums"/> 
											: <EmptyImages data-testid="albums-container-empty" /> 
										: <CircularProgress style={{ display: 'block', margin: '0 auto'}} />}
								</Paper>
							</Grid>
						</Grid>

					</Container>
				</Grid>
			</Grid>
		</Grid>

	)
}

const mapStateToProps = (state, ownProps) => ({
	caseId: caseIdSelector(state),
	caseImages: caseImagesSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	loadCase: (patientId) => dispatch(getCase(patientId)),
	loadImages: (caseId) => dispatch(getCaseImages(caseId))
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(AlbumsContainer)
